import { render, staticRenderFns } from "./TranshipmentNegociationDialog.vue?vue&type=template&id=40f7d1a0&scoped=true"
import script from "./TranshipmentNegociationDialog.vue?vue&type=script&lang=js"
export * from "./TranshipmentNegociationDialog.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentNegociationDialog.vue?vue&type=style&index=0&id=40f7d1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7d1a0",
  null
  
)

export default component.exports